import intervalOfNotes from "./intervalOfNotes";
import getInterval from "./getInterval";
import { IPitch } from "../types";
import { pianoParser } from "./abc";

const getPianoTone = ({ s, a, o = 0 }: IPitch) => {
    return (
        60 +
        pianoParser[s] +
        (a || 0) +
        o * 12
    );
  };

export default (p: IPitch[]) => {
    const orderedP = [...p].sort((noteA, noteB) => {
        return (
            getPianoTone({ s: noteA.s, a: noteA.a, o: noteA.o }) -
            getPianoTone({ s: noteB.s, a: noteB.a, o: noteB.o })
        );
    })
    const step1 = intervalOfNotes(orderedP[0], orderedP[1]);
    const step2 = intervalOfNotes(orderedP[1], orderedP[2]);
    const step3 = orderedP[3] && intervalOfNotes(orderedP[2], orderedP[3]);
    const interval1 = getInterval(step1.i, step1.r);
    const interval2 = getInterval(step2.i, step2.r);
    const interval3 = step3 && getInterval(step3.i, step3.r);
    if (interval1 === "N3") {
        if (interval2 === "k3") {
            if (interval3) {
                if (interval3 === "k3") {
                    return "D7";
                }
            }
            return "Da";
        }
        if (interval2 === "T4") return "m6";
        if (interval2 === "N3") return "Ba";
        if (interval2 === "s4") return "B6";
    } else if (interval1 === "k3") {
        if (interval2 === "T4") return "D6";
        if (interval2 === "N3") return "ma";
        if (interval2 === "k3") {
            if (interval3) {
                if (interval3 === "N2") {
                    return "D5";
                } else if (interval3 === "k3") {
                    return "s7"
                } else if (interval3 === "B2") {
                    return "s5"
                }
            }
            return "sa";
        }
        if (interval2 === "B4") return "s6";
        if (interval2 === "N2" && interval3 === "N3") return "D3";
        if (interval2 === "B2" && interval3 === "k3") return "s3"
    } else if (interval1 === "T4") {
        if (interval2 === "N3") return "D4";
        if (interval2 === "k3") return "m4";
    } else if (interval1 === "s4") {
        if (interval2 === "N3") return "B4";
    } else if (interval1 === "B4") {
        if (interval2 === "k3") return "s4";
    } else if (interval1 === "N2") {
        if (interval2 === "N3" && interval3 === "k3") return "D2";
    } else if (interval1 === "B2") {
        if (interval2 === "k3" && interval2 === "k3") return "s2";
    }
    return "?";
};
